import '../styles/Guess.css';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';

function GuessSword({ rows, swordNow, nbTest }) {
    const { t } = useTranslation();

    console.log('rows', rows, 'swordNow', swordNow);

    const [clickHint1, setClickHint1] = useState(false);
    const [clickHint2, setClickHint2] = useState(false);

    const guessHint1 = 3;
    const guessHint2 = 5;

    const testHint1 = (guessHint1 - nbTest) <= 0 ? 0 : guessHint1 - nbTest;    
    const testHint2 = (guessHint2 - nbTest) <= 0 ? 0 : guessHint2 - nbTest;     // Calculer le nombre d'essais restants pour chaque indice

    function handleClickHint1() {
        if (testHint1 === 0) {
            setClickHint1(true);
        }
    }
    
    function handleClickHint2() {
        if (testHint2 === 0) {
            setClickHint2(true);
        }
    }
    

    return (
        <div className="guess">
            <div className="guess-img">
                <img src={`/images/swords/${swordNow.image_epee}`} alt={swordNow.image_epee} />
            </div>

            <div className="guess-hint">
                {clickHint1 === false ? (
                    <span 
                        className={testHint1 === 0 ? 'hint-clickable' : 'hint-disabled'}
                        onClick={handleClickHint1}
                    >
                        {t('guesssword.hint1.title')} { testHint1 > 0 ? "("+testHint1+" "+t('guesssword.more')+")" : ""} 
                    </span>
                ) : null}

                {clickHint1 === true ? (
                    <span>{t('guesssword.hint1.description')}: {swordNow.loc_epee}</span> // Affiche le paragraphe si clickHint1 est true
                ) : null}
            </div>

            <div className="guess-hint">
                {clickHint2 === false ? (
                    <span 
                        className={testHint2 === 0 ? 'hint-clickable' : 'hint-disabled'}
                        onClick={handleClickHint2}
                    >
                        {t('guesssword.hint2.title')} { testHint2 > 0 ? "("+testHint2+" "+t('guesssword.more')+")" : ""} 
                    </span>
                ) : null}

                {clickHint2 === true ? (
                    <span>{t('guesssword.hint2.description')}: {swordNow.nom_jeu}</span> // Affiche le paragraphe si clickHint2 est true
                ) : null}
            </div>
        </div>
    );
}

export default GuessSword;